export default __webpack_public_path__ + "images/58c5f82c52c5e78743d7606efd115a01-skeleton.png";